import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { FireUIAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { AttachmentFieldError } from '../../common/ui/error';
import { PackageIntlProvider } from '../../common/ui/intl-provider';
import { AttachmentSharedFilmstrip } from '../../common/ui/shared-filmstrip';
import { formatFilesWithViewActions } from '../../common/utils';
import { useViewMediaClientConfig } from '../../services/shared-viewer/attachments-service/main';
import messages from './messages';
import { EmptyStateBox, EmptyStateText } from './styled';
export var AttachmentFieldView = function AttachmentFieldView(props) {
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  return /*#__PURE__*/React.createElement(PackageIntlProvider, {
    locale: locale
  }, /*#__PURE__*/React.createElement(AttachmentFilmstrip, _extends({}, props, {
    "data-test-id": "proforma-attachment-field-view"
  })));
};
export var AttachmentFilmstrip = function AttachmentFilmstrip(props) {
  var files = props.files,
    mediaViewContext = props.mediaViewContext,
    mediaApiError = props.mediaApiError;
  var viewMediaClientConfig = useViewMediaClientConfig(mediaViewContext);
  var intl = useIntl();
  var viewableFiles = files && viewMediaClientConfig ? formatFilesWithViewActions(files, viewMediaClientConfig, '') : [];
  if (!viewMediaClientConfig) {
    return /*#__PURE__*/React.createElement(AttachmentFieldError, {
      error: mediaApiError
    });
  }
  if (viewableFiles.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmptyStateBox, {
      div: true,
      "data-testid": "proforma-attachment-field-view-empty"
    }, /*#__PURE__*/React.createElement(EmptyStateText, null, intl.formatMessage(messages.emptyState))), /*#__PURE__*/React.createElement(AttachmentFieldViewedAnalytic, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AttachmentSharedFilmstrip, {
    viewableFiles: viewableFiles,
    enableDownloadButton: true
  }), /*#__PURE__*/React.createElement(AttachmentFieldViewedAnalytic, null));
};
var AttachmentFieldViewedAnalytic = function AttachmentFieldViewedAnalytic() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FireUIAnalytics, {
    actionSubject: ActionSubject.ATTACHMENT_VIEWER,
    action: Action.VIEWED,
    actionSubjectId: "proformaAttachmentViewerField"
  }));
};